"use client";

import { Button } from "@workspace/ui/components";
import Link from "next/link";
import Image from "next/image";
import { BOOK_DEMO_URL, INSTALL_EXTENSION_URL } from "@/lib/landing-links";

const ITEMS = [
  {
    title: "Know what to say next — live on the call",
    description:
      "The moment an objection lands, Yolk surfaces the one line that turns it — on your screen, mid-call. It catches pricing pushback, flags when the buyer goes quiet, and tells your rep what to say next. Not after. Now.",
    image: "/coaching-os/1-1.png",
  },
  {
    title: "Find out who you are talking with",
    description:
      "Yolk profiles how your prospect thinks and builds a game plan for that one person — so your rep walks in with unique intel before the meeting. Then, during the call, Yolk turns that plan into the exact line to say, right when it matters.",
    image: "/coaching-os/1-2.png",
  },
  {
    title: "Every real call becomes the next drill",
    description:
      "Yolk auto-builds roleplays from your real deals. Reps drill the exact moment that tripped them up — your prospects, your objections, your talk tracks. Until it sticks.",
    image: "/coaching-os/1-3.png",
  },
  {
    title: "See exactly where your deals die",
    description:
      "Connect Gong or Fireflies in one click. Yolk scores every call across the skills that move revenue — and shows you the gaps team-wide and rep-by-rep. You stop guessing who to coach. The map tells you.",
    image: "/coaching-os/1-4.png",
  },
  {
    title: "Watch the numbers move",
    description:
      "Reps who get help in the moment ramp faster, handle objections without flinching, and close more. Managers get 5+ hours a week back — and teams see +$1.5M in revenue per year.",
    image: "/coaching-os/1-5.png",
  },
] as const;

export const Overview = () => {
  return (
    <div className="flex flex-col gap-5 w-full items-center">
      {ITEMS.map((item, i) => (
        <div
          key={i}
          style={{ top: i * 20 + 120 }}
          className="sticky flex flex-col items-center rounded-[32px] bg-white border border-[#e3d8c4] p-5 gap-5 w-full max-w-[1144px] lg:flex-row-reverse lg:p-6 lg:pl-[72px] lg:h-[428px] lg:justify-between lg:overflow-hidden"
        >
          <div className="relative flex shrink-0 w-full aspect-[67/51] lg:w-[500px] lg:h-[348px] lg:aspect-[unset] rounded-[24px] overflow-hidden bg-[#FFF3DC]">
            <Image
              src={item.image}
              alt={item.title}
              fill
              sizes="(min-width: 1024px) 500px, 100vw"
              className="object-cover"
            />
          </div>
          <div className="flex flex-col w-full lg:max-w-[428px] gap-6 lg:gap-10">
            <div className="flex flex-col gap-3">
              <span className="text-lg font-semibold leading-6 lg:text-[24px] lg:leading-8">
                {item.title}
              </span>
              <p className="text-sm font-medium text-d-gray lg:text-base lg:leading-[22px]">
                {item.description}
              </p>
            </div>
            <div className="flex flex-col items-start gap-4 sm:flex-row sm:items-center sm:gap-4">
              <Button
                variant="d-primary"
                className="font-sfpro-rounded h-12"
                asChild
              >
                <Link
                  href={INSTALL_EXTENSION_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Install Free Extension
                </Link>
              </Button>
              <Link
                href={BOOK_DEMO_URL}
                className="text-lg font-semibold text-d-gray underline underline-offset-4 px-2 py-3"
              >
                Book A Demo
              </Link>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
